// AI-ASSISTED: generated with claude-code on 2026-06-10, reviewed by Yoann Hertienne
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useEntity } from '@backstage/plugin-catalog-react';
import { TileBoundary } from '../team-landing/TileBoundary';

const SPACE_ANNOTATION = 'confluence.com/space-key';
const PAGE_ANNOTATION = 'confluence.com/page-id';
const CONFLUENCE_BASE = 'https://luminus.atlassian.net/wiki';

const ConfluenceCardBody = () => {
  const { entity } = useEntity();
  const annotations = entity.metadata.annotations ?? {};
  const space = annotations[SPACE_ANNOTATION];
  const pageId = annotations[PAGE_ANNOTATION];

  if (!space) return null;

  const spaceUrl = `${CONFLUENCE_BASE}/spaces/${encodeURIComponent(space)}/overview`;
  const pageUrl = pageId
    ? `${CONFLUENCE_BASE}/spaces/${encodeURIComponent(space)}/pages/${encodeURIComponent(pageId)}`
    : undefined;
  const searchUrl = `${CONFLUENCE_BASE}/search?spaces=${encodeURIComponent(
    space,
  )}&text=${encodeURIComponent(entity.metadata.name)}`;

  return (
    <Card variant="outlined">
      <CardContent>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Confluence</Typography>
          <Chip size="small" label={`space: ${space}`} />
        </Stack>
        <Typography variant="body2" color="text.secondary" sx={{ pt: 1 }}>
          {pageUrl
            ? 'Open the component page or search the space.'
            : 'Search this space for the component.'}
        </Typography>
      </CardContent>
      <CardActions>
        {pageUrl && (
          <Button
            variant="outlined"
            size="small"
            href={pageUrl}
            target="_blank"
            rel="noreferrer"
            aria-label="Open Confluence page for this component"
          >
            Open page
          </Button>
        )}
        <Button
          variant="outlined"
          size="small"
          href={searchUrl}
          target="_blank"
          rel="noreferrer"
          aria-label="Search Confluence space for this component"
        >
          Search in space
        </Button>
        <Button
          variant="text"
          size="small"
          href={spaceUrl}
          target="_blank"
          rel="noreferrer"
          aria-label="Open Confluence space overview"
        >
          Space overview
        </Button>
      </CardActions>
    </Card>
  );
};

export const ConfluenceCard = () => (
  <TileBoundary tool="Confluence">
    <ConfluenceCardBody />
  </TileBoundary>
);
